import { styleText } from "node:util";

export type Colorize = (value: string) => string;

export function reset(value: string): string {
	return styleText("reset", value);
}

export function bold(value: string): string {
	return styleText("bold", value);
}

export function dim(value: string): string {
	return styleText("dim", value);
}

export function underline(value: string): string {
	return styleText("underline", value);
}

export function yellow(value: string): string {
	return styleText("yellow", value);
}

export function red(value: string): string {
	return styleText("red", value);
}
